<div class="dual-treeview-container">
  <div class="treeview-wrapper" data-tree-side="left">
    <header class="right-tree-header">
      <span class="right-tree-header-search">
        <ejs-textbox
          #leftFilter
          cssClass="e-outline"
          id="list-view-left-filter"
          placeholder="{{ searchTextPlaceholder }}"
          (input)="onFiltering($event, 'left')"
          [htmlAttributes]="{ autocomplete: 'off' }"
        ></ejs-textbox>
      </span>
      <div class="toggle-container">
        <span>
          <mat-slide-toggle
            *ngIf="leftFilterToggleLabel"
            (change)="onFilterToggleChange($event)"
            color="primary"
          >
            {{ leftFilterToggleLabel }}
          </mat-slide-toggle>
        </span>
        <span>
          <mat-slide-toggle
            color="primary"
            class="expand-all-orgs-tgl"
            (change)="onExpandCollapseAllToggle()"
          >
            {{ 'MoveForms.TankMove.ExpandAllOrganizations' | translate }}
          </mat-slide-toggle>
        </span>
      </div>
    </header>
    <div class="tree-viewport-wrapper">
      <cdk-virtual-scroll-viewport #leftViewport [itemSize]="itemSize" class="tree-viewport">
        <ul class="tree-list" role="tree">
          <li
            *cdkVirtualFor="let node of visibleNodesLeft; trackBy: trackByNodeId"
            class="tree-node"
            role="treeitem"
            [attr.aria-level]="(node.level ?? 0) + 1"
            [attr.aria-expanded]="node.hasChildren ? node.expanded : null"
            [style.padding-left.px]="(node.level ?? 0) * 20"
          >
            <span class="tree-node-content">
              <span
                class="tree-node-expand"
                tabindex="0"
                role="button"
                (click)="onExpandClick(node, 'left')"
                (keydown)="onExpandKeydown($event, node, 'left')"
              >
                <ng-container *ngIf="node.hasChildren && (!node.expanded || !isNodeLoading(node.id))">
                  <span class="expand-icon">{{ node.expanded ? '−' : '+' }}</span>
                </ng-container>
                <mat-spinner
                  *ngIf="node.hasChildren && node.expanded && isNodeLoading(node.id)"
                  diameter="20"
                  class="node-loading-spinner"
                ></mat-spinner>
                <span *ngIf="!node.hasChildren" class="expand-placeholder"></span>
              </span>
              <mat-checkbox
                [checked]="isNodeChecked(node)"
                (change)="onCheckboxChange(node, 'left', $event.checked)"
                (click)="$event.stopPropagation()"
                aria-label="{{ node.name }}"
              ></mat-checkbox>
              <mat-icon class="node-type-icon" [attr.aria-hidden]="true">{{
                getNodeIcon(node)
              }}</mat-icon>
              <span class="node-text {{ node?.cssClass }}" [matTooltip]="node.name" [matTooltipDisabled]="tooltipDisabledDuringScroll">
                <ng-container *ngIf="node?.isMatch; else leftNormal">
                  <span
                    [appHighlightSearch]="node.name"
                    [searchTerm]="leftFilterTerm"
                    [enableMultiTokenSearch]="true"
                    [highlightClass]="'highlighted-text'"
                  ></span>
                </ng-container>
                <ng-template #leftNormal>{{ node.name }}</ng-template>
              </span>
              <span *ngIf="shouldShowChildCount(node)" class="child-count">[{{ node.childCount ?? 0 }}]</span>
            </span>
          </li>
        </ul>
      </cdk-virtual-scroll-viewport>
    </div>
    <div *ngIf="DEBUG_MODE" class="debug-console">
      <div *ngFor="let ds of leftDataSourceFiltered">{{ ds | toJSONorString }}</div>
    </div>
  </div>

  <div
    class="e-listbox-tool"
    role="toolbar"
    style="display: flex; flex-direction: column; justify-content: center; gap: 10px"
  >
    <button
      type="button"
      data-value="moveTo"
      title="Move To"
      aria-label="Move To"
      class="e-lib e-btn e-control e-icon-btn"
      (click)="onMoveNodes('left', 'right')"
      [disabled]="!hasCheckedNodes('left')"
    >
      <span class="e-btn-icon e-icons e-moveto"></span>
    </button>
    <button
      type="button"
      data-value="moveFrom"
      title="Move From"
      aria-label="Move From"
      class="e-lib e-btn e-control e-icon-btn"
      (click)="onMoveNodes('right', 'left')"
      [disabled]="!hasCheckedNodes('right')"
    >
      <span class="e-btn-icon e-icons e-movefrom"></span>
    </button>
    <button
      type="button"
      data-value="moveAllTo"
      title="Move All To"
      aria-label="Move All To"
      class="e-lib e-btn e-control e-icon-btn"
      (click)="onMoveAllNodes('left', 'right')"
      [disabled]="!hasNodes('left')"
    >
      <span class="e-btn-icon e-icons e-moveallto"></span>
    </button>
    <button
      type="button"
      data-value="moveAllFrom"
      title="Move All From"
      aria-label="Move All From"
      class="e-lib e-btn e-control e-icon-btn"
      (click)="onMoveAllNodes('right', 'left')"
      [disabled]="!hasNodes('right')"
    >
      <span class="e-btn-icon e-icons e-moveallfrom"></span>
    </button>
  </div>

  <div class="treeview-wrapper" data-tree-side="right">
    <header style="min-height: 38px">
      <h5 *ngIf="rightTreeHeader">
        {{ rightTreeHeader }}<span *ngIf="rightTreeHeaderCount != null">:<span class="header-count-accent">{{ rightTreeHeaderCount }}</span></span>
      </h5>
    </header>
    <div class="tree-viewport-wrapper">
      <cdk-virtual-scroll-viewport #rightViewport [itemSize]="itemSize" class="tree-viewport">
        <ul class="tree-list" role="tree">
          <li
            *cdkVirtualFor="let node of visibleNodesRight; trackBy: trackByNodeId"
            class="tree-node"
            role="treeitem"
            [attr.aria-level]="(node.level ?? 0) + 1"
            [attr.aria-expanded]="node.hasChildren ? node.expanded : null"
            [style.padding-left.px]="(node.level ?? 0) * 20"
          >
            <span class="tree-node-content">
              <span
                class="tree-node-expand"
                tabindex="0"
                role="button"
                [attr.aria-label]="(node.expanded ? 'Collapse' : 'Expand') + ' ' + node.name"
                (click)="onExpandClick(node, 'right')"
                (keydown)="onExpandKeydown($event, node, 'right')"
              >
                <ng-container *ngIf="node.hasChildren">
                  <span class="expand-icon">{{ node.expanded ? '−' : '+' }}</span>
                </ng-container>
                <span *ngIf="!node.hasChildren" class="expand-placeholder"></span>
              </span>
              <mat-checkbox
                [checked]="isNodeChecked(node)"
                (change)="onCheckboxChange(node, 'right', $event.checked)"
                (click)="$event.stopPropagation()"
                aria-label="{{ node.name }}"
              ></mat-checkbox>
              <mat-icon class="node-type-icon" [attr.aria-hidden]="true">{{
                getNodeIcon(node)
              }}</mat-icon>
              <span class="node-text" [matTooltip]="node.name" [matTooltipDisabled]="tooltipDisabledDuringScroll">
                <ng-container *ngIf="node?.isMatch; else rightNormal">
                  <span
                    [appHighlightSearch]="node.name"
                    [searchTerm]="rightFilterTerm"
                    [highlightClass]="'highlighted-text'"
                  ></span>
                </ng-container>
                <ng-template #rightNormal>{{ node.name }}</ng-template>
              </span>
              <span *ngIf="shouldShowChildCount(node)" class="child-count">[{{ node.childCount ?? 0 }}]</span>
            </span>
          </li>
        </ul>
      </cdk-virtual-scroll-viewport>
    </div>
    <div *ngIf="DEBUG_MODE" class="debug-console">
      <div *ngFor="let ds of rightDataSource">{{ ds | toJSONorString }}</div>
    </div>
  </div>
</div>

<div *ngIf="working" class="wait-overlay"></div>
